import { render, staticRenderFns } from "./episode-card-new.vue?vue&type=template&id=794b3ea5&scoped=true&"
import script from "./episode-card-new.vue?vue&type=script&lang=js&"
export * from "./episode-card-new.vue?vue&type=script&lang=js&"
import style0 from "./episode-card-new.vue?vue&type=style&index=0&id=794b3ea5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b3ea5",
  null
  
)

export default component.exports